<div class="footer pam-default-padding black-color">
  <div *ngIf="info$ | async; let info">
    <span>© {{ info.year }} by </span>
    <a
      href="https://www.pathwaystoeducation.ca/"
      target="_blank"
      class="green-color"
      >Pathways Canada.</a
    >

    <span> {{ "All rights reserved" | translate}} </span>
    <span>  |  </span>
    <span> {{ info.clientName }} </span>
    <span>  |  </span>
    <span> UI v{{ clientVersion }} </span>
    <span>  |  </span>
    <span> API v{{ info.version }} </span>
    <span>  |  </span>

    <!-- <a
      href="https://pathwaystoeducation.atlassian.net/servicedesk/customer/portal/5"
      target="_blank"
      class="green-color"
      >{{ "Helpdesk" | translate }}</a
    >
    <span> @ </span> -->
    <a href="mailto:connex@pathwayscanada.ca" class="green-color"
      >connex@pathwayscanada.ca</a
    >
  </div>
</div>
